import React, { Component } from 'react';
import { CaseSettings } from '../../domain/case/CaseDomains';
import { query } from '@trlogic/client-js';
import { TransactionJsonModel, TransactionVariableJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import { RootState } from '../../redux/store';
import { UserSystemAttributes } from '../../domain/rbac/RbacDomains';
import { CaseState } from '../../redux/reducers/CaseReducer';
import { connect } from 'react-redux';
import { changePageFilter, clearPage } from '../../redux/actions/PageActions';
import { changeCaseColumns, changeListComponentLoading, changeTransactionCountLoading } from '../../redux/actions/CaseActions';
import { setAttribute } from '../../redux/actions/UserActions';
import { ConnectedProps } from 'react-redux/es/exports';
import _ from 'lodash';
import axios, { Canceler } from 'axios';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';
import IntervalManager from '../../util/IntervalManager';
import NavigationUtil from 'util/NavigationUtil';
import CustomEmptyComponent from '../../components/custom/CustomEmptyComponent';
import CustomSkeleton from '../../components/custom/CustomSkeleton';
import CustomTable, { CustomColumnProps } from '../../components/custom/CustomTable';
import CustomPaginator, { CustomPaginatorProps } from '../../components/custom/CustomPaginator';
import CustomTableContentWrapper from '../../components/custom/CustomTableContentWrapper';
import DataType from '../../constant/DataType';
import moment from 'moment/moment';
import { ArrayVariableProperties, ObjectVariableProperties, VariableProperties } from '../../domain/datatype/VariablePropertiesDomains';
import TreeNode from 'primereact/treenode';
import { generateUUID } from '../../util/Generator';
import { Tree } from 'primereact/tree';
import { Dialog } from 'primereact/dialog';
import { EntityData } from '../../domain/stream/transaction/EntityDomains';
import EntityService from '../../service/EntityService';
import EntityChatComponent from '../../components/investigation/entity/EntityChatComponent';
import Icon from '../../icons/Icon';
import Filter = query.Filter;
import Order = query.Order;
import QueryBuilder = query.QueryBuilder;
import SelectQuery = query.SelectQuery;
import LanguageUtil from '../../util/LanguageUtil';

class EntityListComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly entityService: EntityService = ServiceContainer.getInstance().get(ServiceNames.ENTITY);

  private readonly intervalManager: IntervalManager = InstanceContainer.get(Injectables.INTERVAL_MANAGER);

  private transactionDataCanceler: Canceler | undefined;

  public render() {
    const { loading, entities, totalRecord, rows, currentPage, structureData, structureVisible, commentModalVisible, selectedEntity } = this.state;
    const { selectedTab } = this.props;
    const isEmpty = entities.length == 0;
    return (
      <div className='w-full h-full flex flex-col overflow-y-scroll max-h-[calc(100vh-400px)] 2xl:max-h-[calc(100vh-400px)] xl:max-h-[calc(100vh-380px)] '>
        {isEmpty ? (
          <div className={'h-[100vh] w-full flex items-center justify-center'}>
            <CustomEmptyComponent
              label={LanguageUtil.get({ id: 'common.label.youCurrentlyDoNotHaveAnyEntities', defaultMessage: 'You currently do not have any entities' })}
            />
          </div>
        ) : loading ? (
          <CustomSkeleton />
        ) : (
          <div>
            <div className={'flex justify-between bg-white items-center w-full'}>
              <CustomTable columns={this.getColumns()} onSortChange={this.onSortChange} value={entities} reorderableColumns />
            </div>
            <CustomPaginator
              currentPage={currentPage}
              currentRecords={entities.length}
              key='entity'
              rows={rows}
              totalRecords={totalRecord > 10_000 ? 10_000 : totalRecord}
              loading={loading}
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
        <Dialog
          className={'h-1/2 w-1/3'}
          headerClassName={'!pb-0'}
          closable={false}
          header={
            <span className={'text-[15px] text-normal'}>{LanguageUtil.get({ id: 'pages.entity.structureItems', defaultMessage: 'Structure Items' })}</span>
          }
          dismissableMask
          closeOnEscape
          visible={structureVisible}
          onHide={this.structureModalClose}
        >
          <Tree value={structureData} className={'border-none h-full w-full text-[13px] p-0 pt-2'} />
        </Dialog>
        <EntityChatComponent
          visible={commentModalVisible}
          onClose={this.commentModalClose}
          updateEntity={this.updateEntity}
          selectedEntity={selectedEntity}
          domain={selectedTab}
        />
      </div>
    );
  }

  public componentDidMount = () => {
    this.startInterval();
  };

  public componentWillUnmount = () => {
    this.stopInterval();
  };

  private startInterval = async () => {
    const { caseSettings } = this.props;
    this.intervalManager.clearEntityIntervals();
    if (caseSettings.length == 0) return;
    this.intervalManager.addEntityInterval(setInterval(async () => await this.onInterval(), 5_000) as any);
    await this.onInterval();
  };

  private restartInterval = async () => {
    this.stopInterval();
    await this.startInterval();
  };

  private stopInterval = () => {
    this.transactionDataCanceler?.();
  };

  private getQuery(
    caseSettings: Pick<CaseSettings, 'id' | 'name' | 'dataSource' | 'keyField'>[],
    filter: Filter,
    rows: number,
    currentPage: number,
    sorts: Order[],
  ): SelectQuery {
    const { selectedTab, channel } = this.props;
    if (caseSettings.length == 0) {
      throw new Error('Alarm domain not found');
    }
    const endpoint = `risk_entity_${NavigationUtil.getTenant()}_${selectedTab}_${channel?.version}`.toLowerCase();
    return QueryBuilder.select()
      .from(endpoint)
      .where(filter)
      .orderBy(...this.getSort(sorts))
      .limit(rows)
      .skip((currentPage - 1) * rows)
      .build();
  }

  private getSort(sorts: Order[]): Order[] {
    if (sorts.length == 0) {
      return [
        {
          operator: 'ASC',
          field: 'id.keyword',
        },
      ];
    }
    return sorts;
  }

  private onSortChange = (sort: Order[]) => {
    this.setState({ sort }, this.restartInterval);
  };

  private onInterval = async () => {
    const { onFetchCount, filter, caseSettings, changeListComponentLoading, selectedTab, channel } = this.props;
    const { rows, currentPage, sort, loading } = this.state;
    const entityQuery = this.getQuery(caseSettings, filter, rows, currentPage, sort);
    if (channel == undefined) return;
    try {
      const token = axios.CancelToken.source();
      this.transactionDataCanceler = token.cancel;
      const { data: entities, count } = await this.entityService.getEntityData(selectedTab, channel.version, entityQuery, token.token);
      this.setState({ totalRecord: count });
      onFetchCount(count);
      if (entities.length != this.state.entities.length || !_.isEqual(entities, this.state.entities) || entities.length == 0 || loading) {
        this.setState({ loading: false, entities: entities, totalRecord: count }, () => {
          changeListComponentLoading(false);
        });
      }
    } catch (e) {}
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    const { onTablePropChange } = this.props;
    const { sort } = this.state;
    this.setState({ currentPage: event.page, rows: event.rows, loading: true }, this.restartInterval);
    onTablePropChange(sort, event.rows, event.page);
  };

  private getColumns = (): CustomColumnProps[] => {
    const { caseSettings, selectedTab, channel } = this.props;
    const baseColumns: CustomColumnProps[] = [
      {
        field: 'id.keyword',
        sortField: 'id.keyword',
        header: LanguageUtil.get({ id: 'pages.entity.table.id', defaultMessage: 'ID' }),
        className: 'min-w-[150px] 2xl:min-w-[200px]',
        alignHeader: 'left',
        columnKey: 'id.keyword',
        copyable: true,
        sortable: false,
        onCopy: (e: EntityData) => {
          return e.id;
        },
        body: (record: EntityData) => {
          return (
            <div className={`flex w-full text-xs 2xl:text-md items-start text-f-black-3 justify-start relative group`}>
              <CustomTableContentWrapper clipSize={20} text={record.id} />
            </div>
          );
        },
      },
      {
        field: 'note.keyword',
        sortField: 'note.keyword',
        header: LanguageUtil.get({ id: 'pages.entity.table.note', defaultMessage: 'Note' }),
        className: 'min-w-[80px] 2xl:min-w-[120px]',
        alignHeader: 'left',
        columnKey: 'note.keyword',
        copyable: false,
        sortable: false,
        body: (record: EntityData) => {
          return (
            <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.commentModalOpen(record)}>
              <Icon icon={'comment'} size={18} color={'#4F4F4F'} className={'hover:text-f-purple hover:cursor-pointer flex items-center justify-center'} />
            </div>
          );
        },
      },
      {
        field: 'updatedAt',
        sortField: 'updatedAt',
        header: LanguageUtil.get({ id: 'pages.entity.table.updateAt', defaultMessage: 'Update At' }),
        className: 'min-w-[180px] 2xl:min-w-[220px]',
        alignHeader: 'left',
        columnKey: 'updatedAt',
        copyable: false,
        sortable: true,
        onCopy: (e: EntityData) => {
          return e?.updatedAt.toString();
        },
        body: (record: EntityData) => {
          return <CustomTableContentWrapper text={record.updatedAt ? moment(record.updatedAt).format('LLL') : ''} />;
        },
      },
    ];
    const variables = caseSettings.flatMap((config) => config.entities).find((e) => e?.name === selectedTab)?.variables || [];

    const variableColumns: CustomColumnProps[] = variables.map((variable) => {
      const channelVariable: TransactionVariableJsonModel | undefined = channel?.variables.find((c) => c?.name == variable);
      return {
        field: channelVariable?.description && channelVariable?.description.length > 0 ? channelVariable?.description : variable,
        sortField: `variables.${variable}${channelVariable?.properties?.dataType == DataType.STRING ? '.keyword' : ''}`,
        header: channelVariable?.description && channelVariable?.description.length > 0 ? channelVariable?.description : variable,
        alignHeader: 'left',
        columnKey: `variables.${variable}`,
        className: channelVariable?.properties?.dataType == DataType.BOOLEAN ? 'min-w-[50px] 2xl:min-w-[80px]' : 'min-w-[220px] 2xl:min-w-[270px]',
        copyable: true,
        sortable: false,
        onCopy: (record: EntityData) => {
          const value = record.variables[variable];
          if (value == undefined || channelVariable?.properties?.dataType == undefined) return 'N/A';
          switch (channelVariable?.properties?.dataType) {
            case DataType.STRING:
              return value;
            case DataType.NUMBER:
              return typeof value == 'number' ? value.toFixed(2) : value;
            case DataType.DATE:
              return moment(value).format('LLL');
            case DataType.BOOLEAN:
              return value ? 'true' : 'false';
            case DataType.OBJECT:
            case DataType.STRUCTURE:
            case DataType.ARRAY:
              return JSON.stringify(value);
            default:
              return value;
          }
        },
        body: (record: EntityData) => {
          return (
            <div className={`flex w-full text-xs 2xl:text-md items-start text-f-black-3 justify-start relative group`}>
              {this.getEntityDataField(record, variable, channelVariable?.properties)}
            </div>
          );
        },
      };
    });

    return [...baseColumns, ...variableColumns];
  };

  private getEntityDataField = (
    record: EntityData,
    variable: string,
    properties: VariableProperties | ObjectVariableProperties | ArrayVariableProperties | undefined,
  ): any => {
    if (record?.variables == undefined || properties?.dataType == undefined) return;
    const value = record.variables[variable];
    if (value == undefined) return 'N/A';
    switch (properties.dataType) {
      case DataType.STRING:
        if (value.length == 0) return 'N/A';
        return <CustomTableContentWrapper text={value} clipSize={30} />;
      case DataType.NUMBER: {
        if (typeof value == 'number') return value.toFixed(2);
        if (typeof value == 'string') {
          try {
            const parsed = Number(value);
            if (isNaN(parsed)) {
              return;
            }
            return parsed?.toFixed(2);
          } catch (e) {
            return value;
          }
        }
        break;
      }
      case DataType.DATE:
        return moment(value).format('LLL');
      case DataType.BOOLEAN:
        return value || value == 'true' ? 'true' : 'false';
      case DataType.OBJECT:
      case DataType.STRUCTURE:
      case DataType.ARRAY:
        return (
          <a
            className={'text-[#458EF7] text-xs 2xl:text-md'}
            onClick={() => this.setState({ structureVisible: true, structureData: this.getStructureData(value) })}
          >
            Items
          </a>
        );
      default:
        return value?.toString() || 'N/A';
    }
  };

  private updateEntity = async () => {
    const { selectedTab, channel, user } = this.props;
    const { selectedEntity } = this.state;
    if (selectedTab == undefined || selectedEntity == undefined || channel == undefined) return;
    let users: string[] = selectedEntity?.metadata?.users || [];
    if (!users.includes(user.username)) {
      users = [...users, user.username];
    }
    try {
      await this.entityService.updateEntityNote(selectedTab, channel.version, selectedEntity.id, users);
    } catch (e) {
      console.error(e);
    }
  };

  private commentModalOpen = (record: EntityData) => {
    this.setState({ commentModalVisible: true, selectedEntity: record });
  };

  private commentModalClose = () => {
    this.setState({ commentModalVisible: false, selectedEntity: undefined });
  };

  private getStructureData = (data: any): TreeNode[] => {
    let result: TreeNode[] = [];
    for (const key in data) {
      result = result?.concat(this.convertItem(data[key], key));
    }
    return result;
  };

  private convertItem(item: any, key: any): TreeNode[] {
    let newItem: TreeNode = {
      key: generateUUID(),
      label: key,
      children: [],
    };
    if (Array.isArray(item)) {
      item.forEach((subItem, index) => {
        const subKey = `${index}`;
        newItem.children = newItem?.children?.concat(this.convertItem(subItem, subKey));
      });
    } else if (typeof item === 'object') {
      for (const subKey in item) {
        newItem.children = newItem?.children?.concat(this.convertItem(item[subKey], subKey));
      }
    } else {
      newItem.label = `${key}: ${item}`;
    }
    return [newItem];
  }

  private structureModalClose = () => {
    const { structureVisible } = this.state;
    this.setState({ structureVisible: !structureVisible });
  };
}

class State {
  loading: boolean = true;
  entities: EntityData[] = [];
  totalRecord: number = 0;
  rows: number = 10;
  currentPage: number = 1;
  sort: Order[] = [];
  structureVisible: boolean = false;
  structureData: TreeNode[] = [];
  commentModalVisible: boolean = false;
  selectedEntity: EntityData | undefined;
}

interface Props extends ReduxProps {
  caseSettings: CaseSettings[];
  filter: Filter;
  onFetchCount: (value: number) => void;
  onTablePropChange: (sort: Order[], rows: number, currentPage: number) => void;
  onChangeFilter: (filter: Filter) => void;
  selectedTab: string | undefined;
  channel: TransactionJsonModel | undefined;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  attributes: state.auth.attributes as UserSystemAttributes,
  case: state.case as CaseState,
});
const connector = connect(mapStateToProps, {
  clearPage,
  changePageFilter,
  changeCaseColumns,
  setAttribute,
  changeListComponentLoading,
  changeTransactionCountLoading,
});
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(EntityListComponent);
